import { render, staticRenderFns } from "./PatternUploader.vue?vue&type=template&id=1dd47012&scoped=true&"
import script from "./PatternUploader.vue?vue&type=script&lang=js&"
export * from "./PatternUploader.vue?vue&type=script&lang=js&"
import style0 from "./PatternUploader.vue?vue&type=style&index=0&id=1dd47012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd47012",
  null
  
)

export default component.exports